import React from "react";
import { LogoutRoute } from "../../../context/AuthContext";
// import { assetPageRoutes } from "../assets/AssetRoutes";

const GenericViewer = React.lazy(() => import("../../layouts/GenericViewer"));

const AdhocReports = React.lazy(
  () => import("../../pages/reports/AdhocReports"),
);

const SettingsPage = React.lazy(() => import("../settings/SettingsPage"));
const DashboardPage = React.lazy(() => import("./DashboardPage"));
const GenericForm = React.lazy(() => import("../../layouts/GenericForm"));
const GenericRegister = React.lazy(
  () => import("../../layouts/GenericRegister"),
);

const DashboardRoutes = [
  {
    path: "/",
    component: <DashboardPage />,
    exact: true,
  },
  {
    path: "/register/:id",
    component: <GenericRegister />,
    exact: true,
  },
  {
    path: "/register/:id/:status",
    component: <GenericRegister />,
    exact: true,
  },
  {
    path: "/:source_id/create",
    component: <GenericForm />,
    exact: true,
  },
  {
    path: "/:source_id/create/:parent_id",
    component: <GenericForm />,
    exact: true,
  },
  {
    path: "/:source_id/drafts/:draft_id",
    component: <GenericForm />,
    exact: true,
  },
  {
    path: "/:source_id/update/:id",
    component: <GenericForm />,
    exact: true,
  },
  {
    path: "/:source_id/view/:id",
    component: <GenericViewer />,
    exact: true,
  },
  {
    path: "/settings",
    component: <SettingsPage />,
    exact: true,
  },

  // // Assets
  // ...assetPageRoutes,

  // Reports
  {
    path: `/reports/adhoc`,
    component: <AdhocReports />,
    exact: true,
  },

  // Logout
  {
    path: "/logout",
    component: <LogoutRoute />,
    exact: true,
  },
];

export default DashboardRoutes;
